import React, { useEffect, createElement } from 'react';
interface GoogleTagManagerProps {
  gtmId: string;
}
export function GoogleTagManager({
  gtmId
}: GoogleTagManagerProps) {
  useEffect(() => {
    // Define dataLayer array if it doesn't exist
    window.dataLayer = window.dataLayer || [];
    // Add GTM script to head with a more robust approach
    const scriptText = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    // Check if script already exists to avoid duplicates
    const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`);
    if (!existingScript) {
      const script = document.createElement('script');
      script.innerHTML = scriptText;
      script.id = 'gtm-script';
      script.setAttribute('data-gtm-id', gtmId);
      // Add to head
      document.head.insertBefore(script, document.head.firstChild);
      // Log for debugging
      console.log(`GTM script initialized with ID: ${gtmId}`);
    }
    // Clean up function
    return () => {
      // This is mostly for development/testing purposes
      try {
        const script = document.getElementById('gtm-script');
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }
      } catch (e) {
        console.error('Error removing GTM script:', e);
      }
    };
  }, [gtmId]);
  return <div data-gtm-container={gtmId} style={{
    display: 'contents'
  }} data-id="element-98">
      {/* GTM noscript iframe - rendered at the beginning of the body */}
      <noscript data-id="element-99">
        <iframe src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`} height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} title="Google Tag Manager" data-id="element-100" />
      </noscript>
    </div>;
}